import React from 'react'
// @ts-ignore: allow side-effect CSS import without type declarations

import './PolicyPage.css'

import Header from '../header/header'
import Footer from '../footer/footer'

function RefundPolicy() {
    return (
        <div>
            <Header />
            <div className="refund-policy-wrapper">
                <h2 className="refund-policy-title">Refund Policy</h2>
                <p className="refund-policy-meta">
                    <strong>Published on:</strong> 15/05/2024
                </p>

                <h3 className="refund-policy-subtitle">Policy Brief & Purpose</h3>
                <p className="refund-policy-text">
                    According to the authorities involved, the purpose of this policy is to provide the guidelines for granting refunds to students who enroll in programs offered by Meantoir Global Academy Private Limited.
                </p>
                <p className="refund-policy-text">Our Cancellation & Refunds outlines the available options for our students for any cancellation /refund process (Online, Offline and Self-paced & E-Learning Courses).</p>

                <h3 className="refund-policy-subtitle">Scope</h3>
                <p className="refund-policy-text">This Cancellation/Refund policy applies to all the students who enroll for a course with Meantoir Global Academy Private Limited.</p>
                <ol style={{ listStyle: "none" }} className='refund-policy-list'>
                    <li>Step 1: Student should apply for the refund by sending mail to <b style={{ color: "red" }}> info@meantoir.com</b> attached with Payment proof, Course details, Bank details, valid reason for refund.</li>
                    <li>Step 2: The mail received by the Service Department for the service verification process.</li>
                    <li>Step 3: The student will receive a call from Service Department to understand the reasons.</li>
                    <li>Step 4: After the call, if the student agreed to discontinue the application for refund, the Service team will take it forward by providing the services as per the agreed with both parties, via Email with the student’s response and confirmation. </li>
                    <li>Step 5: If the student insisted to continue the application for refund and if he/she is eligible for a refund as per the policy, the same will be forwarded to the management for approval and the student’s learning access will be temporarily deactivated during the entire process. </li>
                    <li>Step 6: If approved, the service team will forward the request to the accounts department for payment verification and the student’s learning access will be permanently deactivated including the access to all the method of communication related to their course.</li>
                    <li>Step 7: Following successful verification of the accounts, the admissible refund amount will be disbursed to the concerned student within 14 business days. The refund shall be limited to the amount remaining after deduction of the applicable student registration fee and any applicable taxes, where a tax invoice has been issued.
                        <br />
                        <br />
                        The student registration fee is non-refundable under any circumstances and shall neither be refunded nor adjusted, irrespective of the reason for cancellation, withdrawal, or non-completion of the program. The applicable student registration fee is as follows:
                        <br />
                        INR 10,000 for Certified Finance Specialist (CFS), Certified Finance Manager (CFM), and Diploma in IFRS.
                        INR 25,000 for Enrolled Agent (EA) and Certified Fraud Examiner (CFE).</li>
                </ol>


                <h3 className="refund-policy-subtitle">Cancellation & Refunds</h3>
                <ol className="refund-policy-list refund-policy-ordered">
                    <li>
                        <strong>Meantoir Global Academy offers refunds under the following condition:</strong>
                        <ul>

                            <li>Refund is issued only in case of withdrawals due to unsatisfactory/delayed training delivery on the part of Meantoir Global Academy and only upon through investigation and approval from the management.</li>
                            <li> Students enrolled for E-Learning courses are not eligible for refund.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Meantoir Global Academy <b style={{ color: "red" }}>will NOT </b>offer refund to students under the following circumstances:</strong>
                        <ul>
                            <li> In case the Student fail to attend the scheduled classes of the course.</li>
                            <li> Refund on batch rescheduled by the participant is not applicable. The only option is to change the schedule as per the available batches provided by Meantoir Global Academy.</li>
                        </ul>
                    </li>

                    <li>
                        Refund request can be initiated by the Student only.
                    </li>

                    <li>
                        Contents of the email should be followed by submitting Payment Proof, Course Details, Bank Details, valid reason for refund and etc.
                    </li>
                </ol>


                <h3 className="refund-policy-subtitle">Payment of Refund</h3>
                <ul className="refund-policy-list">
                    <li>Withdrawal Before the Commencement of the Course: If a learner chooses to withdraw before the commencement of the course, a full refund of the course fee will be processed, after deducting the applicable student registration fee. The student registration fee is non-refundable under any circumstances, regardless of the reason for withdrawal or cancellation.
                        <br />
                        The applicable non-refundable student registration fee is as follows:
                        <br />
                        INR 10,000 for Certified Finance Specialist (CFS), Certified Finance Manager (CFM), and Diploma in IFRS.
                        INR 25,000 for Enrolled Agent (EA) and Certified Fraud Examiner (CFE).</li>
                    <li>Withdrawal during course: If the learner wishes to withdraw within attending 5 days of the course, he/she will be provided with a 50% refund of the course fee, without the student registration fee.</li>
                    <li>If the learner has attended more than 10 days of the course, she/he will not be provided with any refunds</li>
                    <li>Tax Amount of the course fee will be deducted if Tax Invoice were issued to the Student.</li>
                </ul>

                <strong className="refund-policy-subtitle">Meantoir Global Academy Private Limited reserves the right to revise the terms & conditions of this refund policy without any prior notice. Updated on: 14-November-2024</strong>
                <h3 className="refund-policy-subtitle">Governing law & Jurisdiction</h3>
                <p className="refund-policy-text">
                    Any dispute or claim arising out of or in connection with ‘Governing law and jurisdiction’ shall be governed in accordance with the laws of India.
                </p>
            </div>
            <Footer />
        </div>
    )
}

export default RefundPolicy
